<div class="flex flex-col">
    <tabs
        [tabs]="tabs"
        [tabIndex]="tabIndex"
        (tabChange)="tabChange($event)"
    ></tabs>
    <tabs
        [tabs]="subTabs"
        [tabIndex]="subTabIndex"
        (tabChange)="subTabChange($event)"
    ></tabs>
    <div class="custom-legend" *ngIf="showCustomLegend" (click)="toggleTrendline()">
        <span class="legend-color-box"></span>
        <span>Database Average</span>
      </div>
    <div id="chart-container">
        
    </div>
</div>